document.addEventListener("click", (e) => {
  const popupOpener = e.target.closest(".selection_popup_button");
  const commerceShopLink = e.target.closest(".cc-ResultPanel-module-wrap_1jQaz");

  if (commerceShopLink) {
    Shopify.analytics.publish("commerce_connector:shop_click");
  }

  if (popupOpener) {
    Shopify.analytics.publish("commerce_connector:popup_opener_click");
  }
});
